/* eslint-disable */
import { login, logout } from '@/api/login'
import { getUserImgList } from '@/api/userImg'
import { getUrToken, setUrToken, removeUrToken, getUxToken, setUxToken, removeUxToken, setPuxToken, getPuxToken, removePuxToken } from '@/utils/auth'
import { Base64 } from 'js-base64';

const user = {
    state: {
        uxtoken: getUxToken(),
        urtoken: getUrToken(),
        pxdata: '',
        userid: '',
        username: '',
        useremail: '',
        useraddr: '',
        userImg: '',
        orgname: '',
        orgaddr: '',
        orgreg: '',
        orgtmp: false,
        noMemChainAddr: '',
        adminLogin: ''
    },

    mutations: {
        SET_UX_TOKEN: (state, uxtoken) => {
            state.uxtoken = uxtoken
        },
        SET_UR_TOKEN: (state, urtoken) => {
            state.urtoken = urtoken
        },
        SET_USER_ID: (state, userid) => {
            state.userid = userid
        },
        SET_USER_NAME: (state, username) => {
            state.username = username
        },
        SET_USER_EMAIL: (state, useremail) => {
            state.useremail = useremail
        },
        SET_USER_ADDR: (state, useraddr) => {
            state.useraddr = useraddr
        },
        SET_USER_IMG: (state, userImg) => {
            state.userImg = userImg
        },
        SET_ORG_NAME: (state, orgname) => {
            state.orgname = orgname
        },
        SET_ORG_ADDR: (state, orgaddr) => {
            state.orgaddr = orgaddr
        },
        SET_ORG_REG: (state, orgreg) => {
            state.orgreg = orgreg
        },
        SET_ORG_TMP: (state, orgtmp) => {
            state.orgtmp = orgtmp
        },
        SET_ADMIN_LOGIN: (state, admLogin) => {
            state.adminLogin = admLogin
        }
    },

    actions: {
        Login({ commit }, userInfo) {
            const userId = userInfo.username.trim()
            return new Promise((resolve, reject) => {
                login(userId, userInfo.password).then(response => {
                    const data = response.rdata
                    commit('SET_UR_TOKEN', data.urx)
                    commit('SET_UX_TOKEN', data.uax)
                    commit('SET_USER_ID', data.certuser.userId)
                    commit('SET_USER_NAME', data.certuser.userName)
                    commit('SET_USER_EMAIL', data.certuser.userEmail)
                    commit('SET_USER_ADDR', data.certuser.userChainAddr)
                    commit('SET_ORG_NAME', data.certuser.orgName)
                    commit('SET_ORG_ADDR', data.certuser.orgChainAddr)
                    commit('SET_ORG_REG', data.certuser.organizationRegistrationNumber)
                    commit('SET_ORG_TMP', data.certuser.tempOrganization)

                    getUserImgList(JSON.stringify({ chainAddress: data.certuser.userChainAddr })).then(response => {
                        if (response.rdata.userImg) {
                            var UserImgUrl = process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.userImg.imgSequence
                        } else {
                            var UserImgUrl = ''
                        }
                        commit('SET_USER_IMG', UserImgUrl)
                    })

                    var bobj = Base64.encode(JSON.stringify(data.certuser))
                    setPuxToken(bobj)

                    setUrToken(data.urx)
                    setUxToken(data.uax)
                    resolve()
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })

            }).catch(error => {
                reject(error)
            })
        },
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.urtoken).then(() => {
                    commit('SET_UX_TOKEN', '')
                    commit('SET_UR_TOKEN', '')
                    removeUxToken()
                    removeUrToken()

                    commit('SET_USER_ID', '')
                    commit('SET_USER_NAME', '')
                    commit('SET_USER_EMAIL', '')
                    commit('SET_USER_ADDR', '')
                    commit('SET_USER_IMG', '')
                    commit('SET_ORG_NAME', '')
                    commit('SET_ORG_ADDR', '')
                    commit('SET_ORG_REG', '')
                    commit('SET_ORG_TMP', false)
                    removePuxToken()

                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_UX_TOKEN', '')
                commit('SET_UR_TOKEN', '')
                removeUxToken()
                removeUrToken()

                commit('SET_USER_ID', '')
                commit('SET_USER_NAME', '')
                commit('SET_USER_EMAIL', '')
                commit('SET_USER_ADDR', '')
                commit('SET_USER_IMG', '')
                commit('SET_ORG_NAME', '')
                commit('SET_ORG_ADDR', '')
                commit('SET_ORG_REG', '')
                commit('SET_ORG_TMP', false)
                removePuxToken()

                resolve()
            })
        },
        refreshUx({ commit }, uax) {
            return new Promise(resolve => {
                // console.log(uax)
                commit('SET_UX_TOKEN', '')
                commit('SET_UX_TOKEN', uax)
                setUxToken(uax)
                resolve()
            })
        },
        setUrdata({ commit }) {
            //  console.log('setUrdata')
            var certuser = JSON.parse(Base64.decode(getPuxToken()))
            commit('SET_USER_ID', certuser.userId)
            commit('SET_USER_NAME', certuser.userName)
            commit('SET_USER_EMAIL', certuser.userEmail)
            commit('SET_USER_ADDR', certuser.userChainAddr)
            commit('SET_ORG_NAME', certuser.orgName)
            commit('SET_ORG_ADDR', certuser.orgChainAddr)
            commit('SET_ORG_REG', certuser.organizationRegistrationNumber)
            commit('SET_ORG_TMP', certuser.tempOrganization)

            getUserImgList(JSON.stringify({ chainAddress: certuser.userChainAddr })).then(response => {
                if (response.rdata.userImg) {
                    var UserImgUrl = process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.userImg.imgSequence
                } else {
                    var UserImgUrl = ''
                }
                commit('SET_USER_IMG', UserImgUrl)
            })

        },
        updateUsrdata({ commit }, userinfo) {
            //  console.log('update store userinfo')
            var certuser = JSON.parse(Base64.decode(getPuxToken()))
            certuser.userName = userinfo.userName
            commit('SET_USER_NAME', certuser.userName)
            var bobj = Base64.encode(JSON.stringify(certuser))
            setPuxToken(bobj)
        },
        updateOrgdata({ commit }, orginfo) {
            //   console.log('update store orginfo')
            var certuser = JSON.parse(Base64.decode(getPuxToken()))
                //  console.log('data~ test ' + orginfo)
            certuser.orgName = ''
            certuser.organizationRegistrationNumber = ''
            certuser.orgChainAddr = ''
            certuser.orgName = orginfo.organizationName
            certuser.organizationRegistrationNumber = orginfo.organizationRegistrationNumber
            certuser.orgChainAddr = orginfo.chainAddress
            certuser.tempOrganization = orginfo.tempOrganization

            commit('SET_ORG_NAME', certuser.orgName)
            commit('SET_ORG_ADDR', certuser.orgChainAddr)
            commit('SET_ORG_REG', certuser.organizationRegistrationNumber)
            commit('SET_ORG_TMP', certuser.tempOrganization)
            var bobj = Base64.encode(JSON.stringify(certuser))
            setPuxToken(bobj)
        },
        NoMemLogin({ commit }, noMem) {
            return new Promise((resolve, reject) => {
                const data = noMem
                commit('SET_UR_TOKEN', data.urx)
                commit('SET_UX_TOKEN', data.uax)
                commit('SET_USER_ID', data.certuser.userId)
                commit('SET_USER_NAME', data.certuser.userName)
                commit('SET_USER_EMAIL', data.certuser.userEmail)
                commit('SET_USER_ADDR', data.certuser.userChainAddr)
                commit('SET_ORG_NAME', data.certuser.orgName)
                commit('SET_ORG_ADDR', data.certuser.orgChainAddr)
                commit('SET_ORG_REG', data.certuser.organizationRegistrationNumber)
                commit('SET_ORG_REG', data.certuser.tempOrganization)

                getUserImgList(JSON.stringify({ chainAddress: data.certuser.userChainAddr })).then(response => {
                    if (response.rdata.userImg) {
                        var UserImgUrl = process.env.VUE_APP_URL_USER_THUMBNAIL + response.rdata.userImg.imgSequence
                    } else {
                        var UserImgUrl = ''
                    }
                    commit('SET_USER_IMG', UserImgUrl)
                })

                var bobj = Base64.encode(JSON.stringify(data.certuser))
                setPuxToken(bobj)

                setUrToken(data.urx)
                setUxToken(data.uax)
                resolve()
            }).catch(error => {
                reject(error)
            })
        },
        AdminLogin({ commit }, admin) {
            return new Promise((resolve, reject) => {
                const data = admin

                commit('SET_ADMIN_LOGIN', data)

                resolve()
            }).catch(error => {
                reject(error)
            })
        },
    }
}

export default user